import { useEffect } from 'react'
import { FilterDescriptor } from '@progress/kendo-data-query'
import { Select } from 'antd'
import { SelectValue } from 'antd/es/select'
import { useAppDispatch, useAppSelector } from 'store'
import { fetchBonusLabelsAction } from 'store/wallet/wallet-actions'
import { useApiClient } from 'utils/api/ApiClient'
import { WalletsApiClient } from 'utils/api/walletsApiClient'
import { isEmpty } from 'utils/is-empty'

interface FilterProps {
  filter: FilterDescriptor
  onFilterChange: (event: { nextFilter: FilterDescriptor }) => void
}

export const BonusLabelFilter: React.FC<FilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const dispatch = useAppDispatch()
  const walletApiClient = useApiClient(WalletsApiClient)
  const bonusLabels = useAppSelector((state) => state.wallet.bonusLabels)

  useEffect(() => {
    if (isEmpty(bonusLabels)) {
      dispatch(fetchBonusLabelsAction(walletApiClient))
    }
  }, [])

  return (
    <Select
      placeholder='Bonus Label'
      value={filter.value || undefined}
      onChange={(value: SelectValue) => {
        onFilterChange({
          nextFilter: { ...filter, value },
        })
      }}
      style={{ width: '250px' }}
      allowClear
    >
      {bonusLabels.map((bonusLabel) => (
        <Select.Option key={bonusLabel.id} value={bonusLabel.id}>
          {bonusLabel.name}
        </Select.Option>
      ))}
    </Select>
  )
}
